import { Checkbox, Group } from "@assetwatch/ui";
import type { FeedbackVerdict } from "./api";
import { nextFeatureVerdict } from "./lib";

/**
 * Useful / Not useful for one feature. Used by the chart and the form. Every
 * pair has the same checkbox labels, so the group carries the feature's name
 * for screen readers.
 */
export function FeatureVerdictBoxes({
  featureLabel,
  verdict,
  disabled = false,
  onVerdict,
}: {
  featureLabel: string;
  verdict: FeedbackVerdict | null;
  /** Greys out both boxes, e.g. while saved feedback is locked. */
  disabled?: boolean;
  onVerdict: (verdict: FeedbackVerdict | null) => void;
}) {
  return (
    <fieldset
      aria-label={`${featureLabel} verdict`}
      className="m-0 min-w-0 border-0 p-0"
    >
      <Group gap={16} wrap="nowrap">
        <Checkbox
          checked={verdict === "useful"}
          disabled={disabled}
          label="Useful"
          onCheckedChange={(checked) =>
            onVerdict(nextFeatureVerdict(verdict, "useful", checked === true))
          }
        />
        <Checkbox
          checked={verdict === "not_useful"}
          disabled={disabled}
          label="Not useful"
          onCheckedChange={(checked) =>
            onVerdict(
              nextFeatureVerdict(verdict, "not_useful", checked === true),
            )
          }
        />
      </Group>
    </fieldset>
  );
}
